export const classNames = Object.freeze({
    // component class names
    labeledDataList: "labeledDataList",
    labeledDataRow: "labeledData__row",
    labeledData: "labeledData",
    labeledDataLabel: "labeledData__label",
    labeledDataData: "labeledData__data",

    // layout class names
    vertical: "vertical",
    horizontal: "horizontal",
    centered: "centered",
    noSpacing: "noSpacing",
    inline: "inline",

    // framework class names
    selectorLabel: "selectorLabel",
    selectorData: "selectorData",
    decorativeLabel: "decorativeLabel",
    visualLabel: "visualLabel",
    titleMargin: "js-title-margin",
    srOnly: "sr-only"
});
